// ClientScroller.jsx
import React from 'react';
import './ClientScroller.css';

const clients = [
  "Vasavi",
  "Ramoji Film City",
  "GNR Infra Developers",
  "APTA Labs",
  "Pavan Lifespace Projects",
  "V-Scientific India Pvt. Ltd.",
  "Gamut Infra",
  "Rohini Minerals Pvt. Ltd.",
  "Mahidhara Projects Pvt. Ltd.",
  "Rockwell International School",
  "Rockwoods International School",
  "Maheswari Fasteners and Bright Pvt. Ltd."
];

const ClientScroller = () => {
  return (
    <div className="scroller-container">
      <div className="scroller-track">
        {[...clients, ...clients, ...clients, ...clients].map((client, index) => (
          <span key={index} className="client-name">{client}</span>
        ))}
      </div>
    </div>
  );
};

export default ClientScroller;
